import React, { useContext, useState, useRef } from "react";
import {Card, Overlay} from "react-bootstrap";
import { UserContext } from "../../providers/UserProvider";
import { firestore } from "../../firebase";
import NavBar from "../../components/NavBar";
import Container from "@material-ui/core/Container";
import CssBaseline from "@material-ui/core/CssBaseline";

import "./style.css";

const SavedLeads = () => {
  const user = useContext(UserContext);
  const [userData, setUserData] = useState("");
  const [leadsData, setLeadsData] = useState("");
  const userRef = firestore.collection("usersData").doc(user.uid);
  const leadsRef = firestore.collection("leadsData");
  const leadsDoc = []

  const [showOverlay, setShowOverlay] = useState(false);
  const [currentClickedLead, setCurrentClickedLead] = useState("");
  const overlayTarget = useRef(null);

  const [userFavLeads, setUserFavLeads] = useState([]);
  const [showFavIconFull, setShowFavIconFull] = useState('none');
  const [showFavIconEmpty, setShowFavIconEmpty] = useState('unset');


  React.useEffect(() => {
    userRef
      .get()
      .then((doc) => {
        if (doc.exists) {
          let data = doc.data();
          setUserData(data);
          setUserFavLeads(data.userFavLeads || [])
        } else {
          // doc.data() will be undefined in this case
          setUserData(null);
          console.log("No such document!");
        }
      })
      .catch(function (error) {
        setUserData(null);
        console.log("Error getting document:", error);
      });
  }, []);

  React.useEffect(() => {
    leadsRef.get().then((querySnapshot) => {      
        querySnapshot.forEach((doc) => {
          leadsDoc.push({ id: doc.id, ...doc.data() })
        })
        setLeadsData(leadsDoc);

    })
  }, []);

  const handleFavLead = async (leadid) =>{
      let tempFavLeadsArr = userFavLeads.filter(arrLead => arrLead !== leadid)
      setUserFavLeads(tempFavLeadsArr)
      await userRef.update({userFavLeads: tempFavLeadsArr})
  }

  const sections = [
    { title: "פרופיל", url: "/Profile"},
    { title: "אח בוגר", url: "#" },
    { title: "פורום מקצועי", url: "#" },
    { title: "הפניות תיקים", url: "/SearchLead" },
  ];


  if (!userData || !leadsData) return <div>Loading Data</div>;
  if(userFavLeads.length === 0) return <div>
     <CssBaseline />
        <Container maxWidth="lg">
          <NavBar sections={sections} />
        </Container>
      <hr />
      <div className='empty-fav-leads-wrapper'>
        <span className = 'empty-fav-leads'> כאן יופיעו התיקים ששמרת.</span>
      </div>
    </div>

  const favLeadsDataArray = leadsData.filter(favLead => userFavLeads.includes(favLead.id))

  return (
    <div>
      <CssBaseline />
      <Container maxWidth="lg">
        <NavBar sections={sections} />
      </Container>
      <hr />
      <Overlay target={overlayTarget.current} show={showOverlay} placement="auto">
        {({
          placement,
          scheduleUpdate,
          arrowProps,
          outOfBoundaries,
          show: _show,
          ...props
        }) => (
          <div
            {...props}
            style={{
              backgroundColor: '#999999e5',
              // padding: '200px 100px',
              color: 'white',
              borderRadius: 5,
              width: '99%',
              height: '99%',
              display: 'flex',
              justifyContent: 'center', 
              direction: 'rtl',
              textAlign: 'right',
              ...props.style,
            }}
          >
          <Card style={{ width: "50%"}} onClick={() => setShowOverlay(!showOverlay)}>
          <Card.Body>
            <Card.Title className="mb-2 text-muted">{currentClickedLead.leadExp}</Card.Title>
            <Card.Subtitle style={{marginTop: '40px'}} className="mb-2 text-muted">
              {currentClickedLead.leadLocation}
            </Card.Subtitle>
            <Card.Text style={{marginTop: '40px'}} className="mb-2 text-muted">
              {currentClickedLead.leadDescription}
            </Card.Text>
            <Card.Link style={{lineHeight: '10'}} href={`/Profile/${user.uid}`} className="mb-2 text-muted">{currentClickedLead.userFullName}</Card.Link>        
          </Card.Body>
        </Card>
          </div>
        )}
      </Overlay>

      <div className='searchlead-page-cards-wrapper'>
        {favLeadsDataArray.map((lead)=>
        <Card style={{ width: "18rem" }}>
          <Card.Body>
            <Card.Title ref={overlayTarget} onClick={() => {setShowOverlay(!showOverlay)
              setCurrentClickedLead(lead)}}>{lead.leadExp} <span className='lead-post-date'>{lead.leadDate}</span></Card.Title>
            <Card.Subtitle className="mb-2 text-muted" ref={overlayTarget} onClick={() => {setShowOverlay(!showOverlay)
              setCurrentClickedLead(lead)}}>
              {lead.leadLocation}
            </Card.Subtitle>
            <Card.Text className='card-text-outside' ref={overlayTarget} onClick={() => {setShowOverlay(!showOverlay)
              setCurrentClickedLead(lead)}}>
              {lead.leadDescription}
            </Card.Text>
            <Card.Link>{lead.userFullName}</Card.Link>
            <i style={{marginRight: "150px", fontSize: '30px'}} class="fa fa-trash" onClick={()=>handleFavLead(lead.id)}></i>
          </Card.Body>
        </Card>
        )}
        
      </div>
    </div>
  );
};

export default SavedLeads;
